import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue"))
}